module.exports = __webpack_public_path__ + "officialStatic/img/parentD.bde945e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/parentD.png
// module id = wX6g
// module chunks = 0